import React from 'react';
import PropTypes from 'prop-types';
import ReceiptIcon from './ReceiptIcon';

function ReceiptNotificationIcon(props) {
  const { style } = props;
  return (
    <div style={style}>
      <ReceiptIcon />
    </div>
  );
}

ReceiptNotificationIcon.propTypes = {
  style: PropTypes.shape({
    backgroundColor: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
  }),
};
ReceiptNotificationIcon.defaultProps = {
  style: {
    marginLeft: '5px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '100%',
    backgroundColor: '#EBEDF2',
    width: '40px',
    height: '40px',
  },
};

export default ReceiptNotificationIcon;
